export default function SciPy_Syllabus() {
  return (
    <div>
      <h1>SciPy Syllabus</h1>
    </div>
  );
}
